/**
 * Development-only console logging helpers.
 * Ensures production bundles do not leak potentially sensitive information
 * through browser developer tools while preserving local diagnostics.
 */

type ConsoleMethod = "log" | "warn" | "error" | "info" | "debug";

const isDev = import.meta.env.DEV;

function emit(method: ConsoleMethod, args: unknown[]): void {
  if (!isDev) {
    return;
  }

  const consoleMethod = console[method] as (...args: unknown[]) => void;
  consoleMethod(...args);
}

export function logDev(...args: unknown[]): void {
  emit("log", args);
}

export function infoDev(...args: unknown[]): void {
  emit("info", args);
}

export function warnDev(...args: unknown[]): void {
  emit("warn", args);
}

export function errorDev(...args: unknown[]): void {
  emit("error", args);
}

export function debugDev(...args: unknown[]): void {
  emit("debug", args);
}
